import React from 'react';
import type { Availability } from 'src/components/HotelCard/types';
import { useTranslation } from '@lt/localization';

import styles from './hotelCardAvailability.module.css';

type HotelCardAvailabilityProps = {
  availability: Availability;
  isHotelOnly: boolean;
  isInAdjacentToursBlock?: boolean;
};

const HotelCardAvailability: React.FC<HotelCardAvailabilityProps> = ({
  availability,
  isHotelOnly,
  isInAdjacentToursBlock = false,
}) => {
  const { flight, hotel } = availability;

  const { t } = useTranslation();

  if (!(flight === 'few') && !(hotel === 'few')) {
    return null;
  }

  return (
    <div
      className={
        isInAdjacentToursBlock
          ? styles.containerInAdjacentToursBlock
          : styles.container
      }
    >
      <p className={styles.warningTextPlacesEnd}>
        {!isHotelOnly
          ? t('hotelcard.card.fewFlight')
          : t('hotelcard.card.fewHotel')}
      </p>
    </div>
  );
};

export default HotelCardAvailability;
